/* INNERDAY gut quiz: screens and navigation. Content and rules live in gut-quiz-core.js. */
(function () {
  'use strict';

  var Q = window.InnerdayGutQuiz;
  var root = document.querySelector('[data-gut-quiz]');
  if (!Q || !root || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';

  var config = JSON.parse(root.querySelector('[data-gut-quiz-config]').textContent);
  if (new URLSearchParams(window.location.search).get('view') === 'gut-quiz') {
    config.guidePath = window.location.pathname + '?view=gut-guide';
  }
  var stage = root.querySelector('[data-gq-stage]');
  var progress = root.querySelector('[data-gq-progress]');
  var progressLabel = root.querySelector('[data-gq-progress-label]');
  var progressBars = Array.prototype.slice.call(root.querySelectorAll('[data-gq-bar]'));
  var CURRENT_YEAR = new Date().getFullYear();
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var loadingTimer = null;

  var state = startState();

  function startState() {
    var saved = Q.load();
    var params = new URLSearchParams(window.location.search);
    if (saved && params.get('edit') === '1' && saved.result) {
      saved.screen = 'Q01';
      saved.editing = true;
      return saved;
    }
    if (saved && saved.result) {
      var fresh = Q.emptyState();
      fresh.firstName = saved.firstName;
      fresh.birthYear = saved.birthYear;
      return fresh;
    }
    if (saved && saved.screen && saved.screen !== 'under18') return saved;
    return Q.emptyState();
  }

  /* ---------- DOM helpers ---------- */

  function el(tag, props, children) {
    var node = document.createElement(tag);
    props = props || {};
    Object.keys(props).forEach(function (key) {
      var value = props[key];
      if (value === null || value === undefined || value === false) return;
      if (key === 'className') node.className = value;
      else if (key === 'text') node.textContent = value;
      else if (key.indexOf('on') === 0) node.addEventListener(key.slice(2).toLowerCase(), value);
      else node.setAttribute(key, value === true ? '' : value);
    });
    (children || []).forEach(function (child) {
      if (child === null || child === undefined || child === false) return;
      node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    });
    return node;
  }

  function chevron() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', 'gq-button__icon');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'm9.5 6.5 5.5 5.5-5.5 5.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function check() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'm6 12.5 4 4 8-9');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function ring() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('class', 'gq-load__ring');
    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('cx', '12');
    circle.setAttribute('cy', '12');
    circle.setAttribute('r', '9');
    circle.setAttribute('fill', 'none');
    circle.setAttribute('stroke', 'currentColor');
    circle.setAttribute('stroke-width', '2');
    circle.setAttribute('stroke-linecap', 'round');
    circle.setAttribute('stroke-dasharray', '14 43');
    svg.appendChild(circle);
    return svg;
  }

  function primary(label, props) {
    props = props || {};
    props.className = 'button gq-button' + (props.className ? ' ' + props.className : '');
    if (!props.type) props.type = 'submit';
    return el('button', props, [el('span', { className: 'gq-button__label', text: label }), chevron()]);
  }

  function backButton() {
    return el('button', { type: 'button', className: 'gq-back', onClick: goBack }, ['← Back']);
  }

  function nav(label, extra) {
    return el('div', { className: 'gq-nav' }, [backButton(), primary(label, extra)]);
  }

  function errorLine(id) {
    return el('p', { className: 'gq-error', id: id, role: 'alert', hidden: true });
  }

  function showError(node, message) {
    node.textContent = message;
    node.hidden = !message;
  }

  function portrait(expertId, className) {
    var expert = Q.EXPERTS[expertId];
    return el('img', {
      className: className || 'gq-portrait',
      src: config.images[expertId],
      alt: expert.name,
      width: '900',
      height: '1200',
      loading: 'lazy'
    });
  }

  function whyBox(text) {
    if (!text) return null;
    return el('div', { className: 'gq-why' }, [
      el('p', { className: 'gq-why__label', text: 'Why we ask' }),
      el('p', { text: text })
    ]);
  }

  function nameSuffix(sentence) {
    var name = (state.firstName || '').trim();
    return name ? sentence + ', ' + name : sentence;
  }

  /* ---------- Navigation ---------- */

  function list() {
    return Q.screens(state);
  }

  function goTo(screen) {
    state.screen = screen;
    persist();
    render();
    window.scrollTo(0, 0);
  }

  function goNext() {
    var screens = list();
    var index = screens.indexOf(state.screen);
    goTo(screens[Math.min(index + 1, screens.length - 1)]);
  }

  function goBack() {
    if (state.screen === 'under18') return goTo('birth');
    var screens = list();
    var index = screens.indexOf(state.screen);
    if (screens[index - 1] === 'loading') index -= 1;
    if (index > 0) goTo(screens[index - 1]);
  }

  function persist() {
    try {
      Q.save(state);
      return true;
    } catch (error) {
      return false;
    }
  }

  function partFor(screen) {
    var match = /^(intro|note)_(\d)$/.exec(screen);
    if (match) return { part: Number(match[2]), fraction: match[1] === 'note' ? 1 : 0 };
    var position = Q.slotPosition(screen);
    if (position) return { part: position.part, fraction: (position.index - 1) / position.total };
    return null;
  }

  function updateProgress() {
    var info = partFor(state.screen);
    progress.hidden = !info;
    if (!info) return;
    progressLabel.textContent = 'Part ' + info.part + ' of 4';
    progressBars.forEach(function (bar, index) {
      var fill = index + 1 < info.part ? 1 : index + 1 === info.part ? info.fraction : 0;
      bar.style.setProperty('--fill', String(fill));
    });
  }

  /* ---------- Screens ---------- */

  function render() {
    if (loadingTimer) {
      clearTimeout(loadingTimer);
      loadingTimer = null;
    }
    var screens = list();
    if (state.screen === 'notice') state.screen = 'intro_1';
    if (state.screen !== 'under18' && screens.indexOf(state.screen) === -1) state.screen = 'name';
    updateProgress();
    var view;
    var screen = state.screen;
    if (screen === 'name') view = nameScreen();
    else if (screen === 'birth') view = birthScreen();
    else if (screen === 'under18') view = under18Screen();
    else if (screen === 'notice') view = noticeScreen();
    else if (/^intro_\d$/.test(screen)) view = introScreen(Number(screen.slice(-1)));
    else if (/^note_\d$/.test(screen)) view = noteScreen(Number(screen.slice(-1)));
    else if (screen === 'loading') view = loadingScreen();
    else if (screen === 'email') view = emailScreen();
    else view = questionScreen(screen);
    stage.replaceChildren(view);
    stage.dataset.screen = screen;
    var focusTarget = view.querySelector('[data-autofocus]') || view.querySelector('h1, h2');
    if (focusTarget) {
      if (!focusTarget.hasAttribute('tabindex') && !/INPUT|BUTTON/.test(focusTarget.tagName)) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
    }
  }

  function nameScreen() {
    var input = el('input', {
      id: 'GqName',
      className: 'gq-input',
      type: 'text',
      name: 'first_name',
      autocomplete: 'given-name',
      placeholder: 'Your first name',
      maxlength: '40',
      'aria-describedby': 'GqNameError',
      'data-autofocus': true
    });
    input.value = state.firstName || '';
    var error = errorLine('GqNameError');
    var form = el('form', { className: 'gq-card gq-card--center', novalidate: true }, [
      el('h1', { className: 'gq-title', text: 'Hey there!' }),
      el('p', { className: 'gq-lead', text: 'Before we build your customized gut guide, let’s get to know each other.' }),
      el('label', { className: 'gq-label', for: 'GqName', text: 'What’s your first name?' }),
      input,
      error,
      primary('Continue')
    ]);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = input.value.replace(/\s+/g, ' ').trim();
      if (!value) {
        showError(error, 'Add your first name to continue.');
        input.focus();
        return;
      }
      state.firstName = value;
      goNext();
    });
    return form;
  }

  function birthScreen() {
    var input = el('input', {
      id: 'GqBirth',
      className: 'gq-input',
      type: 'text',
      inputmode: 'numeric',
      pattern: '[0-9]*',
      maxlength: '4',
      name: 'birth_year',
      autocomplete: 'bday-year',
      placeholder: 'Birth year',
      'aria-describedby': 'GqBirthError',
      'data-autofocus': true
    });
    if (state.birthYear) input.value = String(state.birthYear);
    var error = errorLine('GqBirthError');
    var form = el('form', { className: 'gq-card gq-card--center', novalidate: true }, [
      el('h1', { className: 'gq-title', text: nameSuffix('Great to meet you') + '!' }),
      el('label', { className: 'gq-label', for: 'GqBirth', text: 'What year were you born?' }),
      input,
      error,
      whyBox('Your gut at 30 may not feel the same as it does at 55. Knowing your age helps us put your symptoms in context and tailor your guide to your stage of life.'),
      nav('Continue')
    ]);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var raw = input.value.trim();
      if (!/^\d{4}$/.test(raw)) {
        showError(error, 'Please enter a four-digit year, like 1988.');
        input.focus();
        return;
      }
      var year = Number(raw);
      if (year > CURRENT_YEAR || year < CURRENT_YEAR - 110) {
        showError(error, 'Please check the year and try again.');
        input.focus();
        return;
      }
      state.birthYear = year;
      if (CURRENT_YEAR - year < 18) {
        goTo('under18');
        return;
      }
      goNext();
    });
    return form;
  }

  function under18Screen() {
    return el('div', { className: 'gq-card gq-card--center' }, [
      el('h1', { className: 'gq-title', text: nameSuffix('Thanks for stopping by') + '.' }),
      el('p', { className: 'gq-lead', text: 'This guide is designed for adults aged 18 and over, so we can’t continue the quiz with you.' }),
      el('p', { className: 'gq-lead', text: 'If something about your gut is bothering you, a parent, guardian, or doctor is a good place to start.' }),
      el('div', { className: 'gq-nav' }, [
        backButton(),
        el('a', { className: 'button gq-button', href: config.homeUrl }, [el('span', { className: 'gq-button__label', text: 'Back to INNERDAY' }), chevron()])
      ])
    ]);
  }

  function noticeScreen() {
    var box = el('input', { type: 'checkbox', id: 'GqConsent', className: 'gq-check__input', 'aria-describedby': 'GqConsentError' });
    box.checked = Boolean(state.consent);
    var error = errorLine('GqConsentError');
    var points = config.notice.points
      .map(function (point) { return point.trim(); })
      .filter(Boolean)
      .map(function (point) { return el('li', { text: point }); });
    var form = el('form', { className: 'gq-card', novalidate: true }, [
      el('h1', { className: 'gq-title gq-title--left', text: config.notice.heading }),
      el('p', { className: 'gq-lead gq-lead--left', text: config.notice.intro }),
      el('ul', { className: 'gq-points' }, points),
      el('label', { className: 'gq-check', for: 'GqConsent' }, [
        box,
        el('span', { className: 'gq-check__box', 'aria-hidden': 'true' }, [check()]),
        el('span', { className: 'gq-check__text', text: config.notice.agree })
      ]),
      error,
      el('p', { className: 'gq-fine' }, [el('a', { href: config.privacyUrl, target: '_blank', rel: 'noopener' }, ['Read our privacy policy'])]),
      nav('Continue')
    ]);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!box.checked) {
        showError(error, 'Please tick the box to continue.');
        box.focus();
        return;
      }
      state.consent = { noticeVersion: Q.NOTICE_VERSION, at: new Date().toISOString() };
      goNext();
    });
    return form;
  }

  var INTROS = {
    1: {
      heading: function () { return nameSuffix('Let’s start with what you’ve been noticing') + '.'; },
      body: ['The bloating. The bathroom visits. The meals that leave you uncomfortable.', 'Tell us what feels familiar, and we’ll take it one step at a time.'],
      cta: 'Let’s begin'
    },
    2: {
      heading: function () { return nameSuffix('Let’s see how this fits into your day') + '.'; },
      body: ['We’ll explore when symptoms show up, what happens around bathroom visits, and any connections you’ve noticed with food.'],
      cta: 'Continue with Maya'
    },
    3: {
      heading: function () { return 'There’s the discomfort itself—and the planning around it.'; },
      body: ['Thinking twice about a meal. Checking where the nearest bathroom is. Wondering how your stomach will feel later.', 'Which of these experiences, if any, feels familiar to you?'],
      cta: 'Continue with Claire'
    },
    4: {
      heading: function () { return nameSuffix('Let’s make your next step more informed') + '.'; },
      body: ['You’ve told us what bothers you and how it fits into your day.', 'Now we’ll look at what you’ve already tried, what happened, and anything we should account for in your guide.'],
      cta: 'Continue with Daniel'
    }
  };

  function introScreen(part) {
    var info = Q.PARTS[part - 1];
    var expert = Q.EXPERTS[info.expert];
    var intro = INTROS[part];
    var form = el('form', { className: 'gq-chapter' }, [
      el('div', { className: 'gq-chapter__media' }, [portrait(info.expert, 'gq-chapter__image')]),
      el('div', { className: 'gq-chapter__copy' }, [
        el('p', { className: 'gq-eyebrow', text: 'Part ' + part + ' of 4 · ' + info.title }),
        el('h1', { className: 'gq-title gq-title--left', text: intro.heading() }),
        el('div', { className: 'gq-chapter__body' }, intro.body.map(function (line) { return el('p', { text: line }); })),
        el('p', { className: 'gq-byline' }, [el('strong', { text: expert.name }), el('span', { text: expert.title })]),
        nav(intro.cta)
      ])
    ]);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      goNext();
    });
    return form;
  }

  function questionScreen(slot) {
    var q = Q.question(slot, state.answers);
    if (!q) {
      state.screen = 'Q01';
      return questionScreen('Q01');
    }
    var position = Q.slotPosition(slot);
    var stored = Q.entry(state.answers, slot);
    var picked = stored ? stored.selected.slice() : [];
    var texts = stored && stored.text ? Object.assign({}, stored.text) : {};
    var multi = q.type === 'multi';
    var groupName = 'gq-' + q.branch;
    var continueButton = primary('Continue', { disabled: !picked.length });
    var fields = {};

    var optionNodes = q.options.map(function (option) {
      var id = groupName + '-' + option.id;
      var input = el('input', {
        type: multi ? 'checkbox' : 'radio',
        name: groupName,
        id: id,
        value: option.id,
        className: 'gq-option__input'
      });
      input.checked = picked.indexOf(option.id) !== -1;
      var label = el('label', { className: 'gq-option', for: id }, [
        input,
        el('span', { className: 'gq-option__mark', 'aria-hidden': 'true' }, [check()]),
        el('span', { className: 'gq-option__label', text: option.label })
      ]);
      var wrap = el('div', { className: 'gq-option-wrap' }, [label]);
      if (option.field) {
        var fieldId = id + '-text';
        var field = el('textarea', {
          id: fieldId,
          className: 'gq-textarea',
          rows: '2',
          maxlength: '500',
          placeholder: option.field,
          'aria-label': option.field
        });
        field.value = texts[option.id] || '';
        field.addEventListener('input', function () { texts[option.id] = field.value; });
        var fieldWrap = el('div', { className: 'gq-option__field', hidden: !input.checked }, [field]);
        fields[option.id] = fieldWrap;
        wrap.appendChild(fieldWrap);
      }
      input.addEventListener('change', function () {
        if (multi) {
          if (input.checked) {
            if (option.exclusive) picked = [option.id];
            else picked = picked.filter(function (value) {
              var other = q.options.filter(function (item) { return item.id === value; })[0];
              return !(other && other.exclusive);
            }).concat(option.id);
          } else {
            picked = picked.filter(function (value) { return value !== option.id; });
          }
        } else {
          picked = [option.id];
        }
        q.options.forEach(function (item) {
          var node = document.getElementById(groupName + '-' + item.id);
          if (node) node.checked = picked.indexOf(item.id) !== -1;
          if (fields[item.id]) fields[item.id].hidden = picked.indexOf(item.id) === -1;
        });
        continueButton.disabled = !picked.length;
      });
      return wrap;
    });

    var noteField = null;
    if (q.note) {
      noteField = el('textarea', {
        id: groupName + '-note',
        className: 'gq-textarea',
        rows: '3',
        maxlength: '800',
        'aria-describedby': groupName + '-note-help'
      });
      noteField.value = texts._note || '';
    }

    var legendId = groupName + '-legend';
    var form = el('form', { className: 'gq-question', novalidate: true }, [
      el('p', { className: 'gq-eyebrow gq-eyebrow--count', text: position.index + ' of ' + position.total }),
      el('fieldset', { className: 'gq-fieldset', 'aria-labelledby': legendId }, [
        el('h1', { className: 'gq-question__title', id: legendId, text: q.text }),
        q.helper ? el('p', { className: 'gq-helper', text: q.helper }) : null,
        el('div', { className: 'gq-options', role: multi ? 'group' : 'radiogroup', 'aria-labelledby': legendId }, optionNodes)
      ]),
      q.note ? el('div', { className: 'gq-note-field' }, [
        el('label', { for: groupName + '-note', className: 'gq-label gq-label--left', text: q.note.label }),
        el('p', { className: 'gq-helper', id: groupName + '-note-help', text: q.note.helper + ' Optional.' }),
        noteField
      ]) : null,
      whyBox(q.why),
      el('div', { className: 'gq-nav' }, [backButton(), continueButton])
    ]);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!picked.length) return;
      var keep = {};
      picked.forEach(function (value) {
        if (texts[value] && texts[value].trim()) keep[value] = texts[value].trim().slice(0, 500);
      });
      if (noteField && noteField.value.trim()) keep._note = noteField.value.trim().slice(0, 800);
      Q.setAnswer(state, slot, q.branch, picked, keep);
      goNext();
    });
    return form;
  }

  function noteScreen(part) {
    var answers = state.answers;
    var note = part === 1 ? Q.helenNote(answers) : part === 2 ? Q.mayaNote(answers) : part === 3 ? Q.claireNote(answers) : Q.danielNote(answers);
    var expert = Q.EXPERTS[note.expert];
    var children = [];
    if (part === 1) {
      var rows = Q.helenSummary(answers);
      if (rows.length) {
        children.push(el('dl', { className: 'gq-summary' }, rows.map(function (row) {
          return el('div', { className: 'gq-summary__row' }, [el('dt', { text: row.label }), el('dd', { text: row.value })]);
        })));
      }
    }
    var noteCard = el('article', { className: 'gq-note' }, [
      el('div', { className: 'gq-note__media' }, [portrait(note.expert, 'gq-note__image')]),
      el('div', { className: 'gq-note__copy' }, [
        el('p', { className: 'gq-eyebrow', text: 'A note from ' + expert.name }),
        el('h1', { className: 'gq-note__heading', text: note.heading }),
        el('p', { className: 'gq-note__body', text: note.body }),
        note.list && note.list.length ? el('ul', { className: 'gq-note__list' }, note.list.map(function (line) { return el('li', { text: line }); })) : null,
        el('p', { className: 'gq-byline' }, [el('strong', { text: expert.name }), el('span', { text: expert.title })])
      ])
    ]);
    children.push(noteCard);
    var cta = 'Continue to Part ' + (part + 1);
    if (part === 2) {
      children.push(el('div', { className: 'gq-bridge' }, [
        el('h2', { className: 'gq-bridge__title', text: 'Next, let’s look at what this has been like to live with.' }),
        el('p', { text: 'Claire will explore how symptoms affect your plans, your confidence around food, and whether stressful periods seem connected.' })
      ]));
    }
    if (part === 3) {
      children.push(el('div', { className: 'gq-bridge' }, [
        el('h2', { className: 'gq-bridge__title', text: nameSuffix('One final part') + '.' }),
        el('p', { text: 'Daniel will look at what you’ve already tried, and what your digestion and gut balance still need.' })
      ]));
    }
    if (part === 4) cta = 'Get my gut guide';
    children.push(nav(cta));
    var form = el('form', { className: 'gq-note-screen' }, children);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      goNext();
    });
    return form;
  }

  var LOADING_ROWS = [
    { expert: 'helen', line: 'Symptoms and bowel patterns' },
    { expert: 'maya', line: 'Meals and daily patterns' },
    { expert: 'claire', line: 'Your gut and everyday life' },
    { expert: 'daniel', line: 'What you’ve tried and what comes next' }
  ];

  function loadingScreen() {
    var rows = LOADING_ROWS.map(function (row, index) {
      var expert = Q.EXPERTS[row.expert];
      return el('li', { className: 'gq-load__row', 'data-state': 'waiting' }, [
        el('span', { className: 'gq-load__face' }, [portrait(row.expert, 'gq-load__image')]),
        el('span', { className: 'gq-load__text' }, [
          el('span', { className: 'gq-load__part', text: 'Part ' + (index + 1) + ' · ' + row.line }),
          el('span', { className: 'gq-load__expert', text: expert.name })
        ]),
        el('span', { className: 'gq-load__status', 'aria-hidden': 'true' }, [ring(), check()])
      ]);
    });
    var status = el('p', { className: 'gq-sr', role: 'status', 'aria-live': 'polite', text: 'Putting your guide together.' });
    var view = el('div', { className: 'gq-card gq-card--center gq-load' }, [
      el('h1', { className: 'gq-title', text: nameSuffix('Putting your guide together') + '.' }),
      el('p', { className: 'gq-lead', text: 'Bringing your four parts into one customized gut guide.' }),
      el('ol', { className: 'gq-load__list' }, rows),
      status
    ]);
    var step = 0;
    var tick = function () {
      if (step > 0) rows[step - 1].dataset.state = 'done';
      if (step < rows.length) {
        rows[step].dataset.state = 'active';
        step += 1;
        loadingTimer = setTimeout(tick, 1250);
      } else {
        status.textContent = 'Your guide is ready.';
        loadingTimer = setTimeout(function () { goTo('email'); }, 350);
      }
    };
    loadingTimer = setTimeout(tick, 150);
    return view;
  }

  function answersHash() {
    return JSON.stringify(state.answers) + '|' + state.firstName + '|' + state.birthYear;
  }

  function emailScreen() {
    var input = el('input', {
      id: 'GqEmail',
      className: 'gq-input gq-input--wide',
      type: 'email',
      name: 'email',
      autocomplete: 'email',
      inputmode: 'email',
      spellcheck: 'false',
      autocapitalize: 'off',
      placeholder: 'Your email address',
      'aria-describedby': 'GqEmailError',
      'data-autofocus': true
    });
    if (state.result && state.result.email) input.value = state.result.email;
    var error = errorLine('GqEmailError');
    var trap = el('input', { type: 'text', name: 'gq_extra_note', tabindex: '-1', autocomplete: 'off', className: 'gq-trap', 'aria-hidden': 'true' });
    var submit = primary(state.editing ? 'Email my updated guide' : 'See my results & email my guide', { className: 'gq-button--wide' });
    var form = el('form', { className: 'gq-card gq-card--center gq-email', novalidate: true }, [
      el('h1', { className: 'gq-title', text: nameSuffix('Your answers are in') + '.' }),
      el('label', { className: 'gq-label', for: 'GqEmail', text: 'Where should we send your customized gut guide?' }),
      el('p', { className: 'gq-lead', text: 'Get a breakdown of what you shared, the patterns worth paying attention to, and practical next steps.' }),
      input,
      trap,
      error,
      submit,
      el('p', { className: 'gq-fine', text: 'Your results will open on the next page, so you can explore them straight away.' }),
      el('div', { className: 'gq-nav gq-nav--start' }, [backButton()])
    ]);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input.value.trim();
      if (!email) {
        showError(error, 'Please enter your email address.');
        input.focus();
        return;
      }
      if (!EMAIL_PATTERN.test(email)) {
        showError(error, 'Please check your email address and try again.');
        input.focus();
        return;
      }
      showError(error, '');
      complete(email.toLowerCase(), submit, error, Boolean(trap.value));
    });
    return form;
  }

  function complete(email, submit, error, isBot) {
    var hash = answersHash();
    if (state.result && state.result.email === email && state.result.hash === hash) {
      window.location.href = config.guidePath;
      return;
    }
    submit.disabled = true;
    submit.querySelector('.gq-button__label').textContent = 'Preparing your guide…';
    var requestType = state.result ? 'update' : 'initial';
    state.result = {
      id: Q.uid(),
      email: email,
      hash: hash,
      createdAt: new Date().toISOString(),
      quizVersion: Q.QUIZ_VERSION,
      routingVersion: Q.ROUTING_VERSION,
      contentVersion: Q.CONTENT_VERSION,
      emailState: 'processing',
      lastRequestedAt: Date.now()
    };
    state.completedAt = state.result.createdAt;
    state.editing = false;
    state.screen = 'email';
    if (!persist()) {
      state.result = null;
      submit.disabled = false;
      submit.querySelector('.gq-button__label').textContent = 'See my results & email my guide';
      showError(error, 'Your results couldn’t be saved yet. Please try again.');
      return;
    }
    var derived = Q.derive(state);
    state.result.stage = derived.stage;
    state.result.route = derived.route;
    if (isBot) {
      window.location.href = config.guidePath;
      return;
    }
    var klaviyo = Q.withTimeout(Q.sendToKlaviyo(config, state, derived, requestType), 8000);
    var supabase = Q.withTimeout(Q.sendToSupabase(config, state, derived), 8000);
    Promise.all([klaviyo, supabase]).then(function (outcomes) {
      state.result.emailState = outcomes[0] === 'ok' ? 'accepted' : outcomes[0] === 'timeout' ? 'processing' : 'failed';
      state.result.stored = outcomes[1] === 'ok';
      persist();
      window.location.href = config.guidePath;
    });
  }

  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var target = event.target;
    if (target && target.classList && target.classList.contains('gq-option__input')) {
      event.preventDefault();
      target.click();
    }
  });

  Q.bindHelp(root);
  render();
})();
